import { computed, defineComponent } from 'vue';
export default defineComponent({
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const checked = computed(() => !!parseInt(props.value));
        return {
            checked,
        };
    },
});
